/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './productViewStyle';
import React, { useState, useEffect } from 'react';
import env from '../../../env';
import utils from '../../../utils';
import { ErrorPopup, Loading, Button, ErrorMessage, useGet, usePost, useRouter, SiteLink } from '../../../components';
import { useAuth } from '../../../auth';
import { ViewPartial } from '../../../cms/pages/partials/viewPartial';
//import { CommonProductBottom } from '../../../cms/pages/partials/commonProductBottom';
// import { ProductTile } from '../productList/productTile';
import { ProductTile } from '../productList/productTileNew';
import FsLightbox from 'fslightbox-react';
import { MetaTag } from '../../../components';
import { AddToCart } from './addToCart';
import Slider from "react-slick";
// import { MdFavorite } from "react-icons/md";

//import { debounce } from '../../../lib/utils-core/debounce';
import { gtm } from '../../../lib/tracking';
// import { FacebookShareButton, FacebookIcon, PinterestShareButton, PinterestIcon } from "react-share";
import { createPortal } from "react-dom";
import { getEnquiryFormModel } from './enquiryFormModel';
import { useForm } from '../../../form';
import { ProductPagePartial } from '../../../cms/pages/partials/productPagePartial';

function Portal({children}){
  const [el] = useState(document.createElement('div'));
  useEffect(() => {
      let mount = document.getElementById("portal-root");
      mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el]);
  return createPortal(children, el);
}

export function ProductView(props) {

  const { query } = useRouter();
  const [loaded, setLoaded] = React.useState(false);
  const get = useGet();
  const productCode = query.id || '';
  const category = query.category || '';
  const slug = query.slug || '';
  //console.log(category, slug, productCode)
  React.useEffect(() => {
    console.log('productview use effect');
    //const url = productCode ? `/api/product/getProduct/${productCode}` : `/api/product/getProductByUrl?category=${category}&slug=${slug}`
    const url = `/api/product/getProduct/${slug}`;
    get.send(env.apiBase + url);
    setLoaded(false);
    // eslint-disable-next-line
  }, [productCode, slug]);

  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  const data = get.response;

  if (get.done() && !loaded) {
    setLoaded(true);
    const pageUrl = productCode ? `/product/${productCode}` : `/products/${category}/${slug}`;
    const pageTitle = data.totalCnt === 0 ? 'No product found' : data.productName;
    gtm.pageView(pageUrl, pageTitle);
  }

  if (!data || data.totalCnt === 0) return <ProductNotAvailable />;
  return (
    <React.Fragment>
      {/* <div className="single-banner banner-item bannerSize--thin"
        style={{ backgroundImage: utils.css.bgUrlStyle(utils.site.resourcePath('/sites/beehive-react/media/banners/adobestock_221175640.jpg')) }}>
      </div> */}
      <Product product={data} />
      {/* <CommonProductBottom /> */}
      <ProductPagePartial/>
      <ViewPartial />
    </React.Fragment>
  );
}

function Product({ product }) {
  console.log("product", product);
  //product.productImages = [];
  // const mainPhoto = product.productImages.length > 0 ? product.productImages[0] : { imageUrl: '/assets/product-empty.png', alt: product.productName };
  //const mainPhoto = {imageUrl: utils.site.resourcePath('/sites/beehive-react/media/products/coastal-flora-1k-hexjar.jpg'), alt: product.productName};
  
  const mainPhoto = product.productImages.length > 0 ?
    { imageUrl: product.productImages[0].imageUrl, alt: product.productImages[0].alt ? product.productImages[0].alt : product.productName } :
    { imageUrl: '/assets/logos/logo.png', alt: product.productName };

  const allPhotos = product.productImages || [];
  //console.log("aaa", allPhotos);
  //const otherPhotos = product.productImages.length > 0 ? product.productImages.filter(x => !x.isPackage) : [];
  const popupImages = allPhotos.map(x => x.imageUrl);

  const [heroImage, setHeroImage] = React.useState(mainPhoto);
  const [openPopup, setOpenPopup] = useState(false);

  const [toggler, setToggler] = React.useState(false);
  //const [popupImages, setPopupImages] = React.useState();
  const [popupIndex, setPopupIndex] = React.useState(0);
  const shareUrl = utils.site.resourcePath('/product/' + product.productSlug);
  const heroImageUrl = utils.site.resourcePath(mainPhoto.imageUrl);

  const enquiryFormModel = getEnquiryFormModel({});
  const enquiryForm = useForm(enquiryFormModel, { usePlaceholder: true });

  // Live Feed (productType 4): check login and purchase so we can show the right button
  const auth = useAuth();
  const isLiveFeed = Number(product.productType) === 4;
  const isDartfish = Number(product.productType) === 5;
  const [liveFeedWatchToken, setLiveFeedWatchToken] = useState(null);
  const [liveFeedEntitlementChecked, setLiveFeedEntitlementChecked] = useState(false);
  React.useEffect(() => {
    if (!isLiveFeed || !product.productId) {
      setLiveFeedEntitlementChecked(true);
      return;
    }
    if (!auth.user) {
      setLiveFeedWatchToken(null);
      setLiveFeedEntitlementChecked(true);
      return;
    }
    let cancelled = false;
    setLiveFeedEntitlementChecked(false);
    (async () => {
      try {
        const token = await auth.user.getIdToken();
        const url = (env.apiBase || '').replace(/\/$/, '') + '/api/order/MyOrders';
        const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok || cancelled) return;
        const orders = await res.json();
        if (!Array.isArray(orders) || cancelled) {
          setLiveFeedEntitlementChecked(true);
          return;
        }
        const productId = product.productId;
        let foundToken = null;
        let seasonPassToken = null;
        for (const order of orders) {
          const items = order.orderItems || order.OrderItems || [];
          for (const item of items) {
            const id = item.productId || item.ProductId;
            const watchToken = item.watchToken || item.WatchToken;
            const name = (item.itemName || item.productName || '').toLowerCase();
            const isSeasonPass = /season pass|all season/i.test(name);
            if (id && watchToken && String(id) === String(productId)) {
              foundToken = watchToken;
              break;
            }
            if (isSeasonPass && watchToken) seasonPassToken = watchToken;
          }
          if (foundToken) break;
        }
        if (!cancelled) setLiveFeedWatchToken(foundToken || seasonPassToken);
        setLiveFeedEntitlementChecked(true);
      } catch (_) {
        if (!cancelled) setLiveFeedEntitlementChecked(true);
      }
    })();
    return () => { cancelled = true; };
  }, [isLiveFeed, auth.user, product.productId]);

  const enquiryFormRender = (name) => enquiryForm.renderControl(name, null);
  const post = usePost();
  const router = useRouter();
  const [sendingStatus, setSendingStatus] = React.useState(null);

  // Dartfish products — same layout as live feed
  if (isDartfish) {
    return (
      <div className="contentPanel productViewPanel">
        <MetaTag data={getMetaTag(product, mainPhoto)} />
        <div className="contentPanel__bg" />
        <div className="container">
          <div className="productView">
            <div itemScope={true} itemType="http://schema.org/Product">
              <meta itemProp="name" content={product.productName} />
              <div itemProp="brand" itemType="http://schema.org/Brand" itemScope>
                <meta itemProp="name" content={env.siteName} />
              </div>
              {product.description && <meta itemProp="description" content={product.description} />}
              {heroImage && heroImage.imageUrl && <link itemProp="image" href={env.baseOrigin + heroImage.imageUrl} />}
              <div className="row">
                <div className="col-md-6 col-12" css={style.productPageCol}>
                  <div css={style.heroImageContainer} className="productView__hero__container">
                    <img css={style.heroImage} className="productView__hero" src={heroImage.imageUrl} alt={heroImage.alt} />
                  </div>
                </div>
                <div className="col-md-6 col-12" css={style.productPageCol}>
                  <h1 className="productView__title" css={style.productViewTitle}>
                    <strong>{product.productName}</strong>
                  </h1>
                  <div className="productView__shortDes" css={style.productViewShortDes}>
                    {product.shortDesc}
                  </div>
                  <div css={style.desc} dangerouslySetInnerHTML={{ __html: product.description }} />
                  <div className="productView__price" css={style.priceText}>
                    <span>Price: </span>
                    <b>{product.priceTextOveriding ? product.priceTextOveriding : 'AU ' + utils.money.formatMoney(product.priceIncTax)}</b>
                  </div>
                  <div css={style.liveFeedBtns}>
                    <SiteLink
                      to={`/checkout/dartfish?productId=${encodeURIComponent(product.productId)}`}
                      className="btn btn-primary"
                    >
                      Subscribe Now
                    </SiteLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ViewPartial />
      </div>
    );
  }
  // const [favorite, setFavorite] = React.useState(() => {
  //   if(localStorage.favorites.includes(product.productId)){
  //     return true;
  //   }
  //   return false;
  // });

  const breadCrumbs = product.breadCrumbs;

  //console.log('favorite', favorite);
  //const [isMobile, setIsMobile] = React.useState(utils.site.isMobile())

  // React.useEffect(() => {
  //   const resized = debounce(() => {
  //     setIsMobile(utils.site.isMobile())
  //   }, 1000)
  //   if (typeof window !== `undefined`) {
  //     window.addEventListener('resize', resized)
  //   }
  //   return () => {
  //     if (typeof window !== `undefined`) {
  //       window.removeEventListener('resize', resized)
  //     }
  //   }

  // })


  function openPopupImage(imageUrl) {
    const inx = utils.array.findIndex(popupImages, x => x === imageUrl);
    setPopupIndex(inx >= 0 ? inx : 0)
    setToggler(!toggler)
  }

  var settings = {
    dots: false,
    infinite: allPhotos.length > 2 ? true : false,
    speed: 1500,
    autoplaySpeed: 3000,
    //fade: true,
    autoplay: false,
    slidesToShow: allPhotos.length >= 3 ? 3 : allPhotos.length,
    slidesToScroll: 1
  };

  const slides = allPhotos.map((photo, index) => <div css = {style.productViewImage} key={index}
    className={`productView__image ${heroImage.imageUrl === photo.imageUrl ? 'current' : ''}`}>
    <div css={style.productViewImageBg} className={`productView__imageBg`}
      style={{ 
        backgroundImage: utils.css.bgUrlStyle(photo.imageUrl)
      }}
      onClick={() => 
        setHeroImage(photo)}
      >
    </div>
    {/* <img src={utils.site.resourcePath(photo.imageUrl)} alt={photo.alt} onClick={() => setHeroImage(photo)} /> */}
    </div>
  );

  function onSubmit(e) {
    enquiryForm.validateForm(e, () => {
      const value = { ...enquiryForm.getValue(), productName : product.productName, emailReceiver: '' };
      //var files = form.getFiles();
      var formData = new FormData();
      formData.append('jsonData', JSON.stringify(value));
      //post.send(env.apiBase + "/api/contact/send", value);
      post.sendFormData(env.apiBase + "/api/cart/sendenquire", formData);
      setSendingStatus('pending');
    })
    //console.log('submitting');
  }

  if (post.done() && sendingStatus === 'pending') {
    //var value = enquiryForm.getValue();
    //gtm.sendEvent('contactFormSubmitted', {contactEmail: value.email} )
    enquiryForm.reset(enquiryFormModel);
    setSendingStatus(null);
    setTimeout(() => {
      setOpenPopup(false);
      document.body.style.overflow = "unset";
    }, 1500);
  }

  return (
    <div className="contentPanel productViewPanel">
      
      <Portal>
        {
          openPopup &&
          <div className="product__enquiry__form__container" css={style.enquiryFormContainer}>
            <form className="contactForm">
              <div className = "closeButton" onClick={() => {
                setOpenPopup(false);
                document.body.style.overflow = "unset";
              }}>
                CLOSE
              </div>
              <div className="enquireNowText">
                Enquire Now
              </div>
              <div className="form-row">
                <div className="col-md-4 mb-2">{enquiryFormRender('name')}</div>
                <div className="col-md-4 mb-2">{enquiryFormRender('phone')}</div>
                <div className="col-md-4 mb-2">{enquiryFormRender('email')}</div>
              </div>
            <div className="form-row">
              <div className="col-md-12 mb-2">{enquiryFormRender('enquiry')}</div>
            </div>

        <div className="form-row">
          <div className="col-md-12 mb-2">
            <div className="actions">
            {/* onClick={onSubmit} status={post.status} */}
              <Button onClick={onSubmit} status={post.status} >Send Message</Button>
              <ErrorMessage errors={post.errors} />
              {post.status === 'done' && 'Successfully sent!'}
            </div>
          </div>
        </div>
    </form>
          </div>
        }
      </Portal>

      <FsLightbox
        toggler={toggler}
        sources={popupImages}
        sourceIndex={popupIndex}
      />
      <MetaTag data={getMetaTag(product, mainPhoto)} />

      <div className="contentPanel__bg">
      </div>
      <div className="container">
        {/* <Breadcrumb breadcrumb={product.breadcrumb} /> */}
        <div className="productView">
          <div itemScope={true} itemType="http://schema.org/Product">
            <meta itemProp="name" content={product.productName} />
            <div itemProp="brand" itemType="http://schema.org/Brand" itemScope>
              <meta itemProp="name" content={env.siteName} />
            </div>

            {product.description && <meta itemProp="description" content={product.description} />}
            {/* {barcodeCleaned && <meta itemProp="sku" content={barcodeCleaned} />} */}
            {heroImage && heroImage.imageUrl && <link itemProp="image" href={env.baseOrigin + heroImage.imageUrl} />}

            <div className="row">
            
            <div className="col-md-10" css={style.productPageCol}>
              {/* {breadCrumbs.map((item, index) => {

              })} */}
              <ul className="breadCrumbs" css = {style.productBreadCrumbs}>
                <li> <SiteLink to = "/"> Home </SiteLink> </li>
                <li> <SiteLink to = "/shop"> Shop </SiteLink> </li>
                {
                  breadCrumbs.map((item, index) =>
                    <li key={index} className={`breadCrumb ${ index === (breadCrumbs.length -1) ? 'last-item' : ''}`}>
                      <SiteLink to = {item.categoryPageUrl}> {item.categoryPageTitle} </SiteLink>
                    </li>
                  )
                }
                <li>{ product.productName }</li>
              </ul>
            </div>

            {/* <div className="col-md-2" css={style.productPageCol} style={{textAlign:'right'}}>
              <MdFavorite css={style.productFavorite} className={`${favorite === true ? 'checked' : ''}`} onClick = {() => {
                setFavorite(pre => {
                  let _localStorageFavorites = localStorage.favorites.replace(product.productId + "|", "");
                  let _new = !pre;
                  if(_new === true){
                    _localStorageFavorites = _localStorageFavorites + product.productId + "|";
                  }
                  localStorage.setItem("favorites", _localStorageFavorites);
                  return _new;
                });
              }}></MdFavorite>
            </div> */}
              
              <div className="col-md-6 col-12" css={style.productPageCol}>
                <div css={style.heroImageContainer} className="productView__hero__container">
                  <img css={style.heroImage} className="productView__hero" src={heroImage.imageUrl} alt={heroImage.alt} onClick={() => openPopupImage(heroImage.imageUrl)} />
                </div>
                {!isLiveFeed && !isDartfish && (
                  <div css={style.productViewImages} className="productView__images">
                    <Slider {...settings} >
                      {slides}
                    </Slider>
                  </div>
                )}

                {/* <div className = "desk__top" css = {style.desktopMobile}>
                  <div className="quote__container" css={style.quoteContainer}>
                    <div className="quote__text">
                      Like this product but doesn't match your specifications? Click for a custom quote.
                    </div>
                    <Button onClick={() => {
                      setOpenPopup(true);
                      document.body.style.overflow = "hidden";
                    }}> CUSTOM QUOTE </Button>
                  </div>

                  <div className="social-media" css={style.socialMedia}>
                    <div className="social-icon-text"> SHARE THIS PRODUCT:</div>
                    <FacebookShareButton url={shareUrl} title="Sharing with Facebook">
                      <FacebookIcon size={50} round={true} />
                    </FacebookShareButton>
                    <PinterestShareButton url={shareUrl} media = {heroImageUrl} title="Sharing with Pinterest" style={{marginLeft:'10px'}}>
                      <PinterestIcon size={50} round={true} />
                    </PinterestShareButton>
                  </div>
                </div> */}
                </div>
                
              <div className="col-md-6 col-12" css={style.productPageCol}>
                
                <h1 className="productView__title" css={style.productViewTitle}>
                  <strong>{product.productName}</strong>
                </h1>
                <div className="productView__shortDes" css={style.productViewShortDes}>
                  {product.shortDesc}
                </div>
                

                <div css={style.desc} dangerouslySetInnerHTML={{ __html: product.description }}></div>
                
                {/* <hr/> */}
                
                {/* <div className="productView__productCode">
                  Product code: <b>{product.productCode}</b>
                </div> */}

                {product.productStatus === 0 && !isLiveFeed && !isDartfish && <AddToCart product={product} />}

                {isLiveFeed && (
                  <>
                    <div className="productView__price" css={style.priceText}>
                      <span>Price: </span>
                      <b>{product.priceTextOveriding ? product.priceTextOveriding : 'AU ' + utils.money.formatMoney(product.priceIncTax)}</b>
                    </div>
                    <div css={style.liveFeedBtns}>
                    {/* Single Watch button: wait for auth to resolve before deciding. Not resolved → loading. Not logged in → checkout (login). Logged in + purchased → watch. Logged in + not purchased → checkout. */}
                    {!auth.isResolved && (
                      <Button disabled className="btn btn-primary">
                        Watch Now
                      </Button>
                    )}
                    {auth.isResolved && !auth.user && (
                      <SiteLink
                        to={`/checkout/live-feed?productId=${encodeURIComponent(product.productId)}`}
                        className="btn btn-primary"
                      >
                        Watch Now
                      </SiteLink>
                    )}
                    {auth.isResolved && auth.user && !liveFeedEntitlementChecked && (
                      <Button disabled className="btn btn-primary">
                        Watch Now
                      </Button>
                    )}
                    {auth.isResolved && auth.user && liveFeedEntitlementChecked && liveFeedWatchToken && (
                      <SiteLink to={`/watch?t=${encodeURIComponent(liveFeedWatchToken)}`} className="btn btn-primary">
                        Watch Now
                      </SiteLink>
                    )}
                    {auth.isResolved && auth.user && liveFeedEntitlementChecked && !liveFeedWatchToken && (
                      <Button
                        className="btn btn-primary"
                        onClick={() => {
                          router.push('/checkout/live-feed?productId=' + encodeURIComponent(product.productId));
                        }}
                      >
                        Watch Now
                      </Button>
                    )}
                  </div>
                  </>
                )}

                {isDartfish && (
                  <>
                    <div className="productView__price" css={style.priceText}>
                      <span>Price: </span>
                      <b>{product.priceTextOveriding ? product.priceTextOveriding : 'AU ' + utils.money.formatMoney(product.priceIncTax)}</b>
                    </div>
                    <div css={style.liveFeedBtns}>
                      <SiteLink
                        to={`/checkout/dartfish?productId=${encodeURIComponent(product.productId)}`}
                        className="btn btn-primary"
                      >
                        Subscribe Now
                      </SiteLink>
                    </div>
                  </>
                )}

                {
                  product.productStatus === 100 && 
                  <Button onClick={() => {
                    setOpenPopup(true);
                    document.body.style.overflow = "hidden";
                  }}> ENQUIRE NOW </Button>
                }

                {
                  product.productStatus === 1 && 
                  <Button disabled> SOLD OUT </Button>
                }

                {
                  product.productStatus === 98 && 
                  <Button disabled> NOT AVAILABLE </Button>
                }

                {/* <div className = "mobile" css = {style.desktopMobile}>
                  <div className="quote__container" css={style.quoteContainer}>
                    <div className="quote__text">
                      Like this product but doesn't match your specifications? Click for a custom quote.
                    </div>
                    <Button onClick={() => {
                      setOpenPopup(true);
                      document.body.style.overflow = "hidden";
                    }}> CUSTOM QUOTE </Button>
                  </div>

                  <div className="social-media" css={style.socialMedia}>
                    <div className="social-icon-text"> SHARE THIS PRODUCT:</div>
                    <FacebookShareButton url={shareUrl} title="Sharing with Facebook">
                      <FacebookIcon size={50} round={true} />
                    </FacebookShareButton>
                    <PinterestShareButton url={shareUrl} title="Sharing with Pinterest" style={{marginLeft:'10px'}}>
                      <PinterestIcon size={50} round={true} />
                    </PinterestShareButton>
                  </div>
                </div> */}

              </div>
            </div>
            <RelatedProducts products={product.relatedProducts} />
          </div>
        </div>

      </div>
    </div>
  )
}

function ProductNotAvailable() {
  return (
    <div className="contentPanel productViewPanel">
      <div className="contentPanel__bg" />
      <div className="container" style={{ textAlign: 'center', padding: '80px 20px', minHeight: '40vh' }}>
        <h1 style={{ marginBottom: '1rem' }}>This product is not available</h1>
        <p style={{ marginBottom: '2rem' }}>
          The product or game you're looking for is no longer available or has been removed.
        </p>
        <SiteLink to="/" className="btn btn-primary">Back to Home</SiteLink>
      </div>
    </div>
  );
}

function getMetaTag(product, mainPhoto) {
  return {
    title: product.productName,
    description: product.metaDesc || product.intro,
    keywords: '',
    heroImageUrl: utils.site.resourcePath(mainPhoto.imageUrl),
    language: 'English',
    country: 'Australia',
    siteName: env.siteName,
    url: utils.site.resourcePath('/product/' + product.productSlug),
    //canonical: utils.site.resourcePath(pageData.pageUrl)
  }
}

function RelatedProducts({ products }) {
  //console.log(products)
  if (!products || products.length === 0) return null;
  return <div className="productView__relatedProducts">
    <h3>RELATED PRODUCTS</h3>
    <div className="productList">
      {products.map((product, index) =>
        <ProductTile product={product} key={product.productCode}>
        </ProductTile>
      )}
    </div>
  </div>
}